import { localStorageWritable } from '../utils/localstoreWritable';

export const adminName = localStorageWritable<string>('adminName', '');
